import ChannelInfo from './ChannelInfo';

export default ChannelInfo;